var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBlueCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0001 0.637482C3.04802 0.637482 0.648438 3.03165 0.648438 5.98915C0.648438 8.94665 3.0426 11.3408 6.0001 11.3408C8.95219 11.3408 11.3518 8.94665 11.3518 5.98915C11.3518 3.03165 8.95219 0.637482 6.0001 0.637482ZM8.42677 5.07915L5.68052 7.8254C5.59927 7.90665 5.49635 7.94457 5.39344 7.94457C5.29052 7.94457 5.1876 7.90665 5.10635 7.8254L3.7576 6.47665C3.60052 6.31957 3.60052 6.05957 3.7576 5.90248C3.91469 5.7454 4.17469 5.7454 4.33177 5.90248L5.39344 6.96415L7.8526 4.50498C8.00969 4.3479 8.26969 4.3479 8.42677 4.50498C8.58385 4.66207 8.58385 4.92207 8.42677 5.07915Z",
    fill: "#6E9FFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueCheck);
export default __webpack_public_path__ + "static/media/icon_blue_check.8ae3b978.svg";
export { ForwardRef as ReactComponent };